// export * from './root-store'


import RootStore from './root-store';
export default RootStore;